<template>
	<div>
		<nav class="navbar navbar-toggleable navbar-expand-lg  navbar-dark">
			<div class="container position-relative ">
				<router-link to="/" class="navbar-brand ">
					<img
						class="navbar-brand__regular img-fluid d-lg-inline-block d-none"
						src="/assets/logo.png"
						alt="brand-logo"
						height="75px"
						width="75px"
					/>
					<img
						class="navbar-brand__sticky img-fluid  d-inline-block d-lg-none"
						src="/assets/logo.png"
						alt="sticky brand-logo"
						height="63px"
						width="63px"
					/>
				</router-link>
				<!--  End of brand logo -->
				<button
					class="navbar-toggler mr-0 pr-0 pl-0 ml-0"
					type="button"
					data-toggle="collapse"
					data-target="#navbarSupplier"
				>
					<span class="navbar-toggler-icon"></span>
				</button>
				<!-- end of Nav toggler -->
				<div
					class="collapse navbar-collapse navbar-dark pr-0 pl-0 pl-lg-4  mr-0 ml-0"
					id="navbarSupplier"
				>
					<ul class="navbar-nav" id="navbar-nav">
						<!-- <li class="nav-item ">
							<router-link to="/" class="nav-link">{{
								$t("header.home")
							}}</router-link>
						</li> -->
						<li class="nav-item ">
							<router-link :to="{name:'SupplierItems'}" class="nav-link"
								>پنل کاربری</router-link
							>
						</li>
						<li class="nav-item " :class="{'active': route=='supplier'}"> 
							<router-link to="/supplier"  class="nav-link "
								>مشاهده مشتریان</router-link
							>
						</li>
						<li class="nav-item " :class="route=='supplierContracts'?'active':''">
							<router-link to="/supplier/contracts" class="nav-link"
								>قراردادها</router-link
							>
						</li>

						<!-- <li class="nav-item">
							<router-link to="/blog" class="nav-link"
								>{{ $t("header.blog") }}
							</router-link>
						</li> -->
						<!-- <li class="nav-item dropdown">
							<router-link to="/about-us" class="nav-link"
							>{{ $t("header.aboutUs") }}
							</router-link>
						</li> -->
						<!-- <li class="nav-item dropdown">
							<router-link to="/contact-us" class="nav-link"
							>{{ $t("header.contactUs") }}
							</router-link>
						</li> -->
						<li class="nav-item"  :class="{'active':route=='supplierCustomerSignUp'}">
							<router-link to="/supplier/customer-signup"  class="nav-link ">
								ثبت نام مشتری
							</router-link>
							
						</li>
							
						<li class="nav-item">
							<button
								type="button"
								class="nav-link "
								data-toggle="modal"
								data-target="#calculator"
							>
								{{$t('supplier.installmentCalculator')}}
							</button>
							
						</li>
					</ul>
					
					<!-- end of nav menu items -->
				</div>

				<div class=" pr-4 pl-0 pl-lg-0 pr-lg-0">
					<span v-if="isLoggedIn" class=" nav-item text-white"
						><router-link
							to="/supplier"
							class="users_name font-size--13   font-w--400"
						>
							{{ getSupplierName }} 
						</router-link>
						|
						<button
							class="font-size--14   font-w--500 users_name"
							@click.prevent="logout"
						>
							خروج
						</button></span
					>
				</div>
				<!-- end of nav CTA button -->
			</div>
			<!-- end of container -->
		</nav>
		<!-- ============================================ CALCULATORE ============================= -->
	 <calculator :title="$t('supplier.installmentCalculator')"></calculator>
		<!-- =================================================================================== -->
	</div>
</template>

<script>

import Calculator from "../../views/Calculator.vue"
export default {
	data() {
		return {
			route:'',
			net_amount: 100000000,
			downpayment: 0.25*100000000,
			number_of_instalment: 12,
			total_amount: 0,
			instalment_amount: 0,
			insalment_cost: 0,
		};
	},
	mounted() {
		this.route = this.$route.name
		this.calculatore();
	},
	watch:
	{
		'$route.name':{
			handler:function()
			{

				this.updateRoute()
			}
		}
	},
	computed: {
		isLoggedIn() {
			return this.$store.getters.isSupplierLoggedIn;
		},
		getSupplierName() {
			return this.$store.getters.getSupplierName;
		},
		downpayment_rate(){
			return (this.downpayment/this.net_amount)
		}
	},
	methods: {
		updateRoute()
		{
			this.route = this.$route.name
		},
		calculatore() {
			let data = {
				net_amount: this.net_amount,
				number_of_instalment: this.number_of_instalment,
				downpayment_rate: this.downpayment_rate
			};
			this.$store
				.dispatch("supplierCalculator", data)
				.then((resp) => {
					console.log(resp),
						// (this.downpayment = resp.body.downpayment), //پیش پرداخت
						(this.total_amount = resp.body.loan_face_value), //مبلغ تسهیلات
						(this.instalment_amount = resp.body.instalment_amount),
						(this.insalment_cost =
							resp.body.total_amount_of_instalments + this.downpayment);
				})
				.catch((err) => {
					console.log(err);
				});
		},
		logout() {
			this.$store
				.dispatch("supplierLogOut")
				.then((resp) => {
					console.log(resp);
					this.$router.push("/");
				})
				.catch((err) => {
					console.log(err);
				});
		},
	},
	components: {
		
		Calculator
	},
};
</script>

<style scoped>
.form-control {
	border-radius: 0px 5px 5px 0px !important;
}
.navbar {
	position: fixed;
	/* height: 50px; */
	padding: 0 0 0 0;
	background: #272a33;
}

.readNumber{
	padding: 16px;
}
@media screen and (max-width:600px) {
	button.navbar-toggler
	{
		left:0;
		height:10%;
		top:25px
	}
	.navbar
	{
		position: absolute;
	}
}
</style>
